import { HtmlDialog } from "../helpers/functions.js";
import JSX from "../helpers/react.js";

async function showEditAnimeDialog(){
    const request = $.ajax({
        url: '/catalog/edit-anime/' + page_id,
        type: 'GET',
        success: onLoadData
    });
    location.hash = '#edit';
    const content:JSX.RefObject = {};
    const $dialog = $(
        <HtmlDialog className="edit-anime" OnClose={()=> {
            request.abort();
            location.hash = '';
        }}>
            <div className="top-data">
                <h1>Редактирование аниме</h1>
                <div className="content" style="display:block;" ref={content}>
                    <div style="text-align: center">
                        <img src="/img/loading.svg" alt="Загрузка..." />
                    </div>
                </div>
            </div>
            <div className="bottom-buttons">
                <div className="cancel-button main-button neutral bordered">Отмена</div>
                <div className="save-button main-button bordered" onClick={
                    ()=>$dialog.find('input[type=submit]')[0]!.click()
                }>Сохранить</div>
            </div>
        </HtmlDialog>
).appendTo('body');

    function onLoadData(data: string) {
        $(content.value!).html(data);
        $dialog.find('select.slim-select')
            .filter(function(){return !(this as any)['slim']})
            .slimSelect(
                v => v
            );
        document.dispatchEvent(new Event('oneditformload'));
        $('.ref-link').trigger('input');
    }
}

$(function (){
    location.hash === '#edit' && showEditAnimeDialog();
})
//@ts-ignore
window['showEditAnimeDialog'] = showEditAnimeDialog;

export {};